import * as React from 'react';
import { createStore, useAtomValue, useSetAtom } from 'jotai';
let ScopeContext = React.createContext({
  store: createStore(),
  parentStore: null,
});
export const ScopeProvider = ({ children }) => {
  let store = React.useMemo(() => createStore(), []);
  let parentStore = React.useContext(ScopeContext).store;
  return React.createElement(
    ScopeContext.Provider,
    {
      value: React.useMemo(
        () => ({
          store,
          parentStore,
        }),
        [store, parentStore],
      ),
    },
    children,
  );
};
export const useScopedAtom = (atom) => {
  let { store, parentStore } = React.useContext(ScopeContext);
  let setAtom = useScopedSetAtom(atom);
  let value = useAtomValue(atom, {
    store,
  });
  let inheritedValue = useAtomValue(atom, {
    store: parentStore || store,
  });
  React.useEffect(() => {
    if (void 0 == value && void 0 != inheritedValue) setAtom(inheritedValue);
  });
  return [value, setAtom];
};
export const useScopedSetAtom = (atom) => {
  let { store } = React.useContext(ScopeContext);
  return useSetAtom(atom, {
    store,
  });
};
